import "@scss/components/menu.scss";
import { $InternalStudentCourse } from "@store/internal-study/students-store";
import { MenuItemT, MenuPanelPropsT } from "@interfaces/common";

import { AttentionSVG } from "@components/svgs";
import { Link } from "react-router-dom";
import { Tooltip } from "@mui/material";
import { StudentCoursesDataT } from "@interfaces/internal-study/students";
import clsx from "clsx";
import { useUnit } from "effector-react";

const MenuItemsComponent: React.FC<{
  items: (MenuItemT & { type: string; disable: boolean; finish: boolean })[];
  onItemClick: () => void;
}> = ({ items }) => {
  const handlerLink = (link: string) => {
    return window.location.pathname === link;
  };

  return (
    <>
      {items.map((item, idx) => (
        <Link
          key={idx}
          to={item.link}
          className={item.disable ? "disable" : ""}
        >
          <div
            className={clsx("menu-item", item.type, {
              active: handlerLink(item.link),
              finish: item.finish,
            })}
          >
            {item.imageSrc && (
              <img
                src={item.imageSrc}
                alt=""
                className={clsx("menu-item-icon")}
              />
            )}
            {item?.text}
            {item?.attention && (
              <Tooltip title={item?.attentionText || ""} placement="top">
                <div className="attention">
                  <AttentionSVG />
                </div>
              </Tooltip>
            )}
          </div>
        </Link>
      ))}
    </>
  );
};

export const MenuPanel: React.FC<MenuPanelPropsT> = ({ onItemClick }) => {
  const course = useUnit($InternalStudentCourse) as StudentCoursesDataT;

  let menuItems: any = [
    {
      imageSrc: "/img/static/sidebar/news.svg",
      text: "Новости компании",
      link: "/#",
      disable: true,
    },
    {
      imageSrc: "/img/static/sidebar/legal-information.svg",
      text: "Подписание документов",
      link: "/#",
      disable: true,
    },
    {
      imageSrc: "/img/static/sidebar/study-center.svg",
      text: "Курсы обучения",
      link: "/",
    },
  ];

  if (Object.keys(course).length && course.course_info.lessons) {
    menuItems.push({
      text: `${course.course_info.title}`,
      link: `/course/${course.id}`,
      type: "course",
    });
    course.course_info.lessons.forEach((lesson, i) => {
      const finish = course.stage > i;
      menuItems.push({
        text: `${lesson.title}`,
        link: `/course/${course.id}/lesson/${lesson.id}`,
        type: "lesson",
        disable: course.stage < i,
        imageSrc: finish ? "/img/static/check-mark.png" : false,
        finish: finish,
      });
    });
  }

  return (
    <nav className="menu">
      <div className="menu-cont">
        <div className="menu-section student">
          <MenuItemsComponent onItemClick={onItemClick} items={menuItems} />
        </div>
        {/* <div className="menu-section">
          <MenuItemsComponent
            onItemClick={onItemClick}
            items={[
              {
                imageSrc: "/img/static/sidebar/feedback.svg",
                text: "Техподдержка",
                link: "/feedback",
              },
            ]}
          />
        </div> */}
      </div>
    </nav>
  );
};
